export const markAsDone = id => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const currentDate = Date.now();
    let historyArray = [];
    var docRef = firestore.collection("orders").doc(id);

    docRef
      .get()
      .then(function(doc) {
        if (doc.exists) {
          historyArray = doc.data().history;
          historyArray.push({
            date: currentDate,
            action: "order has been completed"
          });
          firestore
            .collection("orders")
            .doc(id)
            .update({
              isComplete: true,
              history: historyArray
            })
            .then(() => {
              dispatch({ type: "MARK_AS_DONE", id });
            })
            .catch(err => {
              dispatch({ type: "MARK_AS_DONE_ERROR", err });
            });
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      })
      .catch(function(error) {
        console.log("Error getting document:", error);
      });
  };
};
